import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=25f01bb6&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=25f01bb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f01bb6",
  null
  
)

export default component.exports